export const menuItems = [
    {
        id: 1,
        label: "general.administration",
        isTitle: true
    },
    {
        id: 2,
        label: "general.configuration",
        icon: "bx-home-circle",
        subItems: [
            {
                id: 3,
                label: "general.orderstatus",
                link: { name: "steps", params: { organisationcode: ":organisationcode"}},
                parentId: 2
            },
            {
                id: 4,
                label: "general.clientactions",
                link: { name: "clientactions", params: { organisationcode: ":organisationcode"}},
                parentId: 2
            },
        ]
    },
    {
        id: 5,
        isLayout: true
    },
    {
        id: 6,
        label: "general.orders",
        icon: "bx-calendar",
        link: { name: "workorders", params: { organisationcode: ':organisationcode'}}
    },
    {
        id: 7,
        label: "general.public",
        isTitle: true
    },
    {
        id: 8,
        label: "general.search",
        link: { name: "search", params: { organisationcode: ':organisationcode'}}
    }
];

